export const CLIENT_TABS = [
  {
    value: 'main',
    label: 'Главное',
    shortLabel: 'Главное',
    placement: 'primary',
    icon: 'dashboard',
    accentClassName: 'text-sky-600 dark:text-sky-400',
  },
  {
    value: 'orders',
    label: 'ДТрейд',
    shortLabel: 'ДТрейд',
    placement: 'primary',
    icon: 'orders',
    accentClassName: 'text-emerald-600 dark:text-emerald-400',
  },
  {
    value: 'docs',
    label: 'Докум.',
    shortLabel: 'Докум.',
    placement: 'primary',
    icon: 'docs',
    accentClassName: 'text-amber-600 dark:text-amber-400',
  },
  {
    value: 'contacts',
    label: 'Контакты',
    shortLabel: 'Конт.',
    placement: 'overflow',
    icon: 'contacts',
    accentClassName: 'text-violet-600 dark:text-violet-400',
  },
  {
    value: 'location',
    label: 'Карта',
    shortLabel: 'Карта',
    placement: 'primary',
    icon: 'location',
    accentClassName: 'text-rose-600 dark:text-rose-400',
  },
  {
    value: 'info',
    label: 'Инфо',
    shortLabel: 'Инфо',
    placement: 'overflow',
    icon: 'info',
    accentClassName: 'text-slate-600 dark:text-slate-300',
  },
  {
    value: 'monitoring',
    label: 'Монит.',
    shortLabel: 'Монит.',
    placement: 'primary',
    icon: 'monitoring',
    accentClassName: 'text-cyan-600 dark:text-cyan-400',
  },
  {
    value: 'licensing',
    label: 'Лицензии',
    shortLabel: 'Лиц.',
    placement: 'overflow',
    icon: 'licensing',
    accentClassName: 'text-indigo-600 dark:text-indigo-400',
  },
] as const;

export type ClientTabDefinition = (typeof CLIENT_TABS)[number];
export type ClientTabValue = ClientTabDefinition['value'];

export const PRIMARY_CLIENT_TABS = CLIENT_TABS.filter((tab) => tab.placement === 'primary');
export const OVERFLOW_CLIENT_TABS = CLIENT_TABS.filter((tab) => tab.placement === 'overflow');

const clientTabValues = new Set<string>(CLIENT_TABS.map((tab) => tab.value));

export function isClientTabValue(value: unknown): value is ClientTabValue {
  return typeof value === 'string' && clientTabValues.has(value);
}

export function getClientTabValue(value: string | null | undefined): ClientTabValue {
  return isClientTabValue(value) ? value : 'main';
}

export function getClientTabQuery(value: ClientTabValue): Record<string, string> {
  return value === 'main' ? {} : { tab: value };
}

export function getClientTabDefinition(value: ClientTabValue): ClientTabDefinition {
  return CLIENT_TABS.find((tab) => tab.value === value) ?? CLIENT_TABS[0];
}

export function isOverflowClientTab(value: ClientTabValue): boolean {
  return getClientTabDefinition(value).placement === 'overflow';
}

export function getOverflowClientTabLabel(value: ClientTabValue): string {
  return isOverflowClientTab(value) ? getClientTabDefinition(value).shortLabel : 'Еще';
}
